import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ThumbsDown from '../../icons/ThumbsDown';
import ThumbsUp from '../../icons/ThumbsUp';
import { sendUserAction } from '../../../reducers/history/actions';
import { THUMBSUP, THUMBSDOWN } from '../../../initialiser/constants';

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    height: 18px;
    width: 18px;
    padding: 4px;
    transition: transform 0.15s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    &:hover {
      transform: scale(1.2);
    }
  }

  .zoom {
    animation: like-animation 0.45s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
  }

  @keyframes like-animation {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(1.2);
    }
    50% {
      transform: scale(0.95);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const ReactionWrapper = styled.div`
  position: absolute;
  right: -32px;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
`;

const UserReaction = ({ id, userAction, sendUserAction }) => {
  const [action, setAction] = useState(userAction);

  function handleReaction(action, id) {
    setAction(action);
    sendUserAction(action, id);
  }

  if (action) {
    return (
      <ReactionWrapper>
        <IconWrapper>
          {action === THUMBSUP ? (
            <ThumbsUp isActive={true} className="zoom" />
          ) : (
            <ThumbsDown isActive={true} className="zoom" />
          )}
        </IconWrapper>
      </ReactionWrapper>
    );
  }

  return (
    <ReactionWrapper>
      <IconWrapper onClick={() => handleReaction(THUMBSUP, id)}>
        <ThumbsUp />
      </IconWrapper>
      <IconWrapper onClick={() => handleReaction(THUMBSDOWN, id)}>
        <ThumbsDown />
      </IconWrapper>
    </ReactionWrapper>
  );
};

export default connect(null, { sendUserAction })(UserReaction);



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/UserReaction.js